module.exports = __webpack_public_path__ + "static/media/Roboto-Black.d9526533.woff";